import {putMethod} from '~/api'

export const put = async request => await putMethod(`/api/confirmPrebooking?processId=${request.processId}`)
